import { initializeApp } from "firebase/app"
import { credentials } from '@/plugins/firebase/credentials';

export const App = initializeApp(credentials);
